<template>
  <div class="messagecenterkefutongzhi">
    <XR-head :rightShow="false" ref="headObj"></XR-head>

  
    <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite" ref="scroll">
      <mu-list ref="list" v-for="msgItem in msgList" :key="msgItem.Id">
        <div class="date">{{msgItem.CreateDate}} <span style="padding-left: 10px;">{{titleTextValue}}</span></div>
        <mu-list-item class="problem" :title="msgItem.MsTitle">     
          <div class="reason">
              <span v-html="msgItem.MsContext"></span>
          </div>          
        </mu-list-item>
        <template v-if="msgItem.MsUrl">
          <mu-divider />
          <router-link :to="msgItem.MsUrl">
            <mu-list-item class="xiangqing" :title="msgItem.ButtonText?msgItem.ButtonText:'查看详情'">
                  <mu-icon slot="right" value=":fa fa-angle-right"/>
            </mu-list-item>
          </router-link>
        </template>
      </mu-list>
    </v-scroll>

    <XR-toast ref="XRtoast"></XR-toast>
     <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>

export default {
  data () {
    return {
      pageEnd : 0, // 结束页数
      searchInfo:{
        type: this.$route.query.type,
        pageIndex:1,
        pageSize:5
      },
      scrollDone:function(){},
      msgList : [],      
      titleTextValue:''
    }
  },
  mounted(){
    if(this.searchInfo.type == 1){
      this.titleTextValue = '客服通知'
    }
    else if(this.searchInfo.type == 3){
      this.titleTextValue = '活动通知'
    }
    else if(this.searchInfo.type == 6){
      this.titleTextValue = '系统通知'
    }
    this.$refs.headObj.UpdateTitle(this.titleTextValue)
    this.getMessageList(true)
  },
  methods: {
    getMessageList(isNewSearch){
         
      if(isNewSearch){        
        this.searchInfo.pageIndex=1
      }
      else{        
        this.searchInfo.pageIndex++
      }

      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserMessageTypeList", this.searchInfo
      ).then(function(res) {
        ths.scrollDone()
        if(!res.IsSuccess){
          ths.$refs.XRPageTip.ShowEmpty(res.Msg)    
                   
        }else{    
          ths.loaded =false         
          ths.$refs.XRtoast.hide()


          for(var i = 0; i <  res.Data.List.length; i++){
            res.Data.List[i].MsContext = decodeURIComponent(res.Data.List[i].MsContext)
          }

          if(isNewSearch){
            ths.msgList = res.Data.List
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){            
              ths.msgList.push(res.Data.List[i])
            }
          }

          ths.pageEnd = res.Data.Rows%ths.searchInfo.pageSize!=0? res.Data.Rows/ths.searchInfo.pageSize+1:res.Data.Rows/ths.searchInfo.pageSize

          if(!ths.msgList || ths.msgList.length<=0){            
            ths.$refs.XRPageTip.ShowEmpty(res.Msg)
          }else{            
            ths.$refs.XRPageTip.initTip()
          }
        }
      });      
    },
    
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
       
        //this.$refs.XRtoast.failed("已经到最后一页", true)\
        this.$refs.scroll.infiniteDone()
        return
      }
      this.getMessageList(false);     
    }
  }
}

</script>

<style>
    .messagecenterkefutongzhi .yo-scroll .inner{
      top:-48px;
    }
    .messagecenterkefutongzhi .mu-list{
      background: #fff;
      margin-top: 15px;
      padding-top: 24px;
    }
    .messagecenterkefutongzhi .mu-list .date{
      padding: 0 16px;
      color: #999;
      font-size: 14px;
    }
    .messagecenterkefutongzhi .mu-list .problem .mu-item-title{
      font-size: 14px;
      font-weight: bold;
    }
    .messagecenterkefutongzhi .mu-list .problem .mu-item-content .reason{
      font-size: 14px;
      color: #666;
      padding-top: 16px;
    }
    .messagecenterkefutongzhi .mu-list .problem .mu-item-content .reason img{
      width:100%;
    }
    .messagecenterkefutongzhi .mu-list .mu-divider{
      background-color: #f5f5f5;
      margin-left: 16px; 
    }
    .messagecenterkefutongzhi .router-link-active .mu-item-title{
      font-size: 14px;
      color: #666;
    }
    .messagecenterkefutongzhi .xiangqing .mu-item-title{font-size: 14px;}
    .messagecenterkefutongzhi .xiangqing .mu-item-right{
      color: #eee;
    }
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/messageServiceList.vue